<template>
  <!-- 积分奖励 -->
  <div class="awarding" style="padding-top: 0.49rem">
    <ul class="awarding_title">
      <li
        class="basic"
        :class="isActive == 1 ? 'active' : 'inActiveRight'"
        @click="isActive = 1"
      >
        积分提现
      </li>
      <li
        class="phone"
        :class="isActive == 2 ? 'active' : ''"
        @click="isActive = 2"
      >
        提现记录
      </li>
    </ul>
    <div class="withdrawal" v-show="isActive == 1">
      <div class="alert">
        <img
          src="../../assets/img/personal/icpn_warning@2x.png"
          alt=""
          style="width: 0.12rem; height: 0.12rem; margin-right: 0.08rem"
        />
        提现账号只可设置一次，修改请联系客服
      </div>
      <div style="padding: 0 0.15rem">
        <!-- 当前积分 -->
        <div class="NowCode">
          <div>
            <p
              style="
                font-size: 0.12rem;
                color: #ffffff;
                height: 0.2rem;
                line-height: 0.2rem;
              "
            >
              当前积分
            </p>
            <p
              style="
                font-size: 0.26rem;
                color: #efd7b1;
                height: 0.3rem;
                line-height: 0.3rem;
              "
            >
              {{ withdrawal.money ? parseInt(withdrawal.money) : "--" }}
            </p>
          </div>
          <div
            style="
              width: 0.01rem;
              height: 0.52rem;
              background: #ffffff;
              opacity: 0.4;
            "
          ></div>
          <div>
            <p
              style="
                font-size: 0.12rem;
                color: #ffffff;
                height: 0.2rem;
                line-height: 0.2rem;
              "
            >
              可提现积分
            </p>
            <p
              style="
                font-size: 0.26rem;
                color: #efd7b1;
                height: 0.3rem;
                line-height: 0.3rem;
              "
            >
              {{
                withdrawal.real_money ? parseInt(withdrawal.real_money) : "--"
              }}
            </p>
          </div>
        </div>
        <div class="award_alert">
          温馨提示：根据国家相关规定7天无理由退货期限后才可提现！
        </div>
        <!-- 开户银行 -->
        <!-- 原来绑定了银行卡信息 -->
        <div
          class="awarding_form"
          style="width: 100%; height: 2.22rem"
          v-if="withdrawal.bank_name"
        >
          <van-form @submit="onSubmit">
            <div style="border-radius: 0.08rem; overflow: hidden">
              <van-field
                :value="withdrawal.bank_name"
                readonly
                label="开户银行"
              />
              <van-field
                :value="withdrawal.bank_cardname"
                readonly
                label="开户姓名"
              />
              <van-field
                :value="withdrawal.sfz_card"
                readonly
                label="身份证号"
              />
              <van-field
                :value="withdrawal.bank_card"
                readonly
                label="银行卡号"
              />
              <van-field
                :value="withdrawal.bank_sub"
                readonly
                label="开户支行"
              />
              <van-field
                v-model="drawal"
                name="money"
                label="提现积分"
                placeholder="请输入提现积分"
                :rules="[{ required: true }]"
              />
            </div>
            <div class="btn">
              <van-button round block type="info" native-type="submit">
                立即提现
              </van-button>
            </div>
          </van-form>
        </div>
        <!-- 原来没绑定银行卡信息 -->
        <div class="awarding_form" style="width: 100%; height: 2.22rem" v-else>
          <van-form @submit="onSubmit">
            <div style="border-radius: 0.08rem; overflow: hidden">
              <van-field
                v-model="bank_name"
                name="bank_name"
                label="开户银行"
                placeholder="请输入开户银行"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="bank_cardname"
                name="bank_cardname"
                label="开户姓名"
                placeholder="请输入真实姓名"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="sfz_card"
                name="sfz_card"
                label="身份证号"
                placeholder="请输入身份证号码"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="bank_card"
                type="bank_card"
                name="bank_card"
                label="银行卡号"
                placeholder="请输入银行卡号"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="bank_sub"
                name="bank_sub"
                label="开户支行"
                placeholder="请输入开户支行名称"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="drawal"
                name="money"
                label="提现积分"
                placeholder="请输入提现积分"
                :rules="[{ required: true }]"
              />
            </div>
            <div class="btn">
              <van-button round block type="info" native-type="submit">
                立即提现
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <!-- 提现记录 -->
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      v-show="isActive == 2"
    >
      <div class="withdrawalRecord">
        <div
          class="widthdrawalRecord_content"
          v-for="item in WithdrawallogList"
          :key="item.id"
        >
          <div class="withdrawalRecord_list">
            <h3
              style="
                font-size: 0.17rem;
                color: #333333;
                line-height: 0.2rem;
                height: 0.2rem;
                margin-bottom: 0.09rem;
              "
            >
              申请提现{{ item.original_money }}元
            </h3>
            <p
              style="
                height: 0.2rem;
                font-size: 0.14rem;
                color: #999a9c;
                line-height: 0.2rem;
                height: 0.2rem;
                margin-bottom: 0.07rem;
              "
            >
              提现至招商银行，卡号{{ item.bank_card }}
            </p>
            <div>提现积分：{{ item.money }}</div>
            <div>转购物积分：{{ item.fee_money }}</div>
            <div>申请时间：{{ item.ctime }}</div>
            <div style="margin-bottom: 0.18rem">
              审核状态：
              <span style="color: #a47f00" v-show="item.state == 0">
                待处理
              </span>
              <span style="color: #319f06" v-show="item.state == 1">
                已到账
              </span>
              <span style="color: #ff5d5d" v-show="item.state == 2">
                已拒绝
              </span>
            </div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <!-- 当没有提现记录时 -->
      <div
        v-if="isNone && isActive == 2"
        class="noAddress"
        style="
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f3f1f4;
        "
      >
        <img
          src="../../assets/img/empty/img_blank_content@2x.png"
          alt=""
          style="width: 2.17rem; height: 1.75rem; margin-top: 1.75rem"
        />
        <p
          style="
            height: 0.24rem;
            font-size: 0.12rem;
            color: #99999b;
            line-height: 0.24rem;
          "
        >
          暂无内容
        </p>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  getAwardList,
  dowithdrawalInfo,
  getWithdrawallogList, // 提现记录
} from "../../api/home";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      isNone: false,
      isActive: 1,
      info: {}, // 输入的银行卡信息
      bank_cardname: "", // 姓名
      bank_name: "", // 开户行
      bank_card: "", // 体现的卡号
      bank_sub: "", // 体现的分行
      drawal: "", // 提现的金额
      sfz_card: "", //身份证号
      PayContent: [], //
      withdrawal: {}, // 银行卡以及积分信息
      withdrawal_config: {}, // 体现要求
      page: 1,
      WithdrawallogList: [], // 提现记录
      loading: false,
      finished: false,
    };
  },
  methods: {
    // 立即体现
    onSubmit(values) {
      if (values.money.includes(".")) {
        Toast("提现金额，只能提整数");
      } else {
        Dialog.confirm({
          message:
            "提现审核通过后，将预留" +
            this.withdrawal_config +
            "%转换为购物积分",
        })
          .then(() => {
            // 如果原来有银行卡信息
            if (this.withdrawal.bank_name) {
              dowithdrawalInfo({
                money: values.money,
                bank_name: this.withdrawal.bank_name,
                bank_card: this.withdrawal.bank_card,
                bank_cardname: this.withdrawal.bank_cardname,
                bank_sub: this.withdrawal.bank_sub,
                sfz_card: this.withdrawal.sfz_card,
              })
                .then((res) => {
                  Toast(res.data.msg);
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              dowithdrawalInfo({
                bank_name: values.bank_name,
                bank_card: values.bank_card,
                bank_cardname: values.bank_cardname,
                bank_sub: values.bank_sub,
                money: values.money,
                sfz_card: values.sfz_card,
              })
                .then((res) => {
                  Toast(res.data.msg);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 加载
    onLoad(val) {
      this.loading = true;
      // 提现记录
      getWithdrawallogList({ page: this.page })
        .then((res) => {
          this.page += 1;
          this.WithdrawallogList.push(...res.data.backdata.lists);
          if (this.WithdrawallogList.length >= res.data.ext.total) {
            this.finished = true;
          }
          this.loading = false;
          if (this.WithdrawallogList.length == 0) {
            this.isNone = true;
          } else {
            this.isNone = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
  created() {
    this.onLoad();
    // 积分提现
    getAwardList()
      .then((res) => {
        this.PayContent = res.data.backdata;
        // 银行卡信息
        this.withdrawal = res.data.backdata.withdrawal;
        this.withdrawal_config =
          res.data.backdata.withdrawal_config.withdrawal_fee;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang='scss'>
.awarding {
  height: 100%;
  background: rgb(243, 241, 244);
  .awarding_number {
    width: 100%;
  }
  .awarding_title {
    width: 100%;
    height: 0.59rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    position: fixed;
    z-index: 1;
    li {
      width: 1.41rem;
      height: 0.29rem;
      line-height: 0.29rem;
      text-align: center;
      border: 1px solid #35353d;
      font-size: 0.12rem;
      color: #333333;
      &.basic {
        border-radius: 0.15rem 0rem 0rem 0.15rem;
      }
      &.phone {
        border-left: none;
        border-radius: 0px 0.15rem 0.15rem 0px;
      }
      &.active {
        background: linear-gradient(0deg, #d1ad79 0%, #efd7b1 100%);
        border: 1px solid transparent;
        border-image: linear-gradient(0deg, #dfb981 0%, hsl(37, 68%, 82%) 100%);
        color: #93683d;
      }
      &.inActiveRight {
        border-right: none;
      }
    }
  }
  .withdrawal {
    .alert {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.4rem;
      background: #f6e3ca;
      padding-left: 0.15rem;
      color: #93673d;
      line-height: 0.4rem;
      font-size: 0.12rem;
      margin-top: 0.59rem;
    }
    .NowCode {
      width: 100%;
      height: 1.1rem;
      background: url("../../assets/img/personal/img_bg_integral@2x.png")
        no-repeat;
      background-size: contain;
      margin-top: 0.11rem;
      padding: 0.23rem 0 0.27rem 0;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      div {
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height: 100%;
      }
    }
    .award_alert {
      width: 100%;
      height: 0.43rem;
      line-height: 0.43rem;
      font-size: 0.12rem;
      color: #666666;
    }
    .awarding_form {
      .van-form {
        height: 3.55rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 0.22rem;
      }
      .van-cell {
        font-size: 0.14rem;
        padding: 0.1rem 0 0.1rem 0.15rem;
        color: #333333;
        .van-field__button {
          padding: 0;
          .van-button--small {
            width: 0.8rem;
            height: 0.24rem;
            background: #f0d8b1;
            border-radius: 0.02rem;
            font-size: 0.12rem;
            color: #93683d;
            border: none;
            margin-right: 0.15rem;
          }
        }
      }
      .van-field__label {
        color: #333333;
        width: 0.8rem;
        margin-right: 0;
      }
      .btn {
        display: flex;
        justify-content: center;
        .van-button--info {
          width: 2.72rem;
          height: 0.44rem;
          background: linear-gradient(0deg, #d1ad79 0%, #efd7b1 100%);
          border-radius: 22px;
          border: none;
          font-size: 0.16rem;
          font-weight: bold;
          color: #93673d;
        }
      }
    }
  }
  .withdrawalRecord {
    margin-top: 0.7rem;
    margin-bottom: 0.36rem;
    .widthdrawalRecord_content {
      padding-top: 0.21rem;
      padding-left: 0.15rem;
      background: #ffffff;
      height: 1.94rem;
      .withdrawalRecord_list {
        div {
          line-height: 0.2rem;
          height: 0.2rem;
          margin-bottom: 0.06rem;
          font-size: 0.14rem;
        }
        .line {
          width: 100%;
          height: 0.01rem;
          background: #f3f1f4;
        }
      }
    }
  }
}
</style>
